import { CHANGE_LOCALE, CHANGE_ACADEMIC_MODE, CHANGE_VIEW_SEMESTER } from "../actions";

export const changeLocale = (locale) => {
  localStorage.setItem("currentLanguage", locale);
  return {
    type: CHANGE_LOCALE,
    payload: locale,
  };
};

export const changeAcademicMode = (mode) => {
  localStorage.setItem("academicMode", mode);
  return {
    type: CHANGE_ACADEMIC_MODE,
    payload: mode,
  };
};

/**
 * Updates the per-user semester view preference.
 * Stored in localStorage so it persists across page refreshes for this user/device.
 * Does NOT write to Firestore — the school-wide currentSemester in school settings
 * is the read-only default; this is each user's personal override.
 */
export const changeViewSemester = (semester) => {
  sessionStorage.setItem("viewSemester", semester);
  return {
    type: CHANGE_VIEW_SEMESTER,
    payload: semester,
  };
};
